import { nanoid } from 'nanoid';
import type {
  NotifyType,
  NotifyItem,
  ShowNotifyOptions,
} from '@/shared/ui/AppNotify/model/types/appNotify';

export const useNotifyStore = defineStore('notify', () => {
  const DEFAULT_DURATION = 3000;
  const NOTIFY_ICONS: Record<NotifyType, string> = {
    success: 'CheckNotify',
    error: 'ErrorNotify',
    info: 'InfoNotify',
  };

  const items: Ref<NotifyItem[]> = ref([]);

  const removeNotify = (id: string): void => {
    items.value = items.value.filter((item) => item.id !== id);
  };

  const showNotify = (options: ShowNotifyOptions): void => {
    const { title, type = 'error', duration = DEFAULT_DURATION } = options;
    const id = nanoid();

    items.value.push({ id, title, type });
    setTimeout(() => removeNotify(id), duration);
  };

  return {
    items,
    DEFAULT_DURATION,
    NOTIFY_ICONS,
    showNotify,
    removeNotify,
  };
});
